import React from 'react';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import {
  eqProps, compose, multiply, subtract, defaultTo, flip,
} from 'ramda';

import FeedbackForm from './FeedbackForm';
import { itemsPerPage } from './common';
import { listFeedback } from '../../actions/feedback';
import { isSSR, smoothScroll } from '../../helpers/view';
import analytics from '../../helpers/analytics';
import FeedbackEntry from '../../components/FeedbackEntry';
import Pagination from '../../components/Pagination';
import SheetTitle from '../../components/SheetTitle';
import Error from '../../components/Error';
import LoadingContainer from '../../components/LoadingContainer';

import c from './Feedback.less';

class FeedbackContainer extends React.Component {
  static propTypes = {
    loaded: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    total: PropTypes.number.isRequired,
    feedbackList: PropTypes.array.isRequired,
    listFeedback: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
  };

  UNSAFE_componentWillMount() {
    if (isSSR()) {
      if (Number(this.props.match.params.page) > 0 && this.props.feedbackList.length === 0) {
        this.props.staticContext.page.status = 404;
      }
    }
  }

  componentDidMount() {
    this._browserRenderedAction();

    smoothScroll();
  }

  UNSAFE_componentWillReceiveProps({ match: { params } }) {
    if (!eqProps('page', params, this.props.match.params)) {
      this._loadData(params.page);

      analytics.pageview('/shop/feedback');
    }
  }

  handlePageChange = (page = null) => {
    smoothScroll();

    return this.props.history.push(`/shop/feedback${page ? `/${page}` : ''}`);
  };

  handleFeedbackSubmit = () => {
    this.handlePageChange();

    const { page } = this.props.match.params;
    if (!page || page === 1) {
      this._loadData();
    }
  };

  _browserRenderedAction = () => {
    if (this.props.app.renderedComponent === 'Feedback') return;

    this._loadData(this.props.match.params.page);
  };

  _loadData(page) {
    this.props.listFeedback({
      offset: compose(multiply(itemsPerPage), flip(subtract)(1), defaultTo(1))(page),
      limit: itemsPerPage,
    });
  }

  render() {
    const {
      match: { params }, loading, feedbackList, total, user: { loggedIn },
    } = this.props;

    if (isSSR()) {
      if (Number(params.page) > 0 && feedbackList.length === 0) {
        return <Error errorCode="404" />;
      }
    }

    if (loading && total === 0) {
      return <LoadingContainer />;
    }

    return (
      <div className={c.container}>
        <Helmet defer={false}>
          <title>User Feedback at Mp3Caprice</title>
          <meta name="description" content="Discover, buy and download high quality tunes for reasonable prices." />
          <meta property="mc:dp" content="/shop/feedback" />
          <meta property="mc:page" content="Feedback" />
        </Helmet>
        <SheetTitle title="Feedback" />
        {
        loggedIn ? (
          <FeedbackForm onSubmit={this.handleFeedbackSubmit} />
        ) : null
      }
        {
        !loading && total > 0 ? (
          <div>
            <Spin spinning={loading} size="large">
              {
                feedbackList.map((feedback) => (
                  <FeedbackEntry key={feedback.id} feedback={feedback} />
                ))
              }
            </Spin>
            <Pagination
              showLoadMore={false}
              total={total}
              currentPage={parseInt(params.page || '1', 10)}
              pageSize={itemsPerPage}
              isLoading={loading}
              onPageChange={this.handlePageChange}
              baseHref="/shop/feedback"
            />
          </div>
        ) : null
      }
        {
        !loading && total === 0 ? (
          <div className={c.emptyResultsContainer}>
            <h2>No feedback yet</h2>
            <p>Be the first one to leave.</p>
          </div>
        ) : null
      }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  loading: state.feedback.loading,
  loaded: state.feedback.loaded,
  total: state.feedback.total,
  feedbackList: state.feedback.data,
  user: state.user,
  app: state.app,
});

const mapDispatchToProps = {
  listFeedback,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FeedbackContainer));
